module.exports = "/_next/static/images/platform_1-349ee283db998d18b2c3431e23961c35.png";